import { useMemo, useState } from 'react';
import PublicDataTable from '../components/PublicDataTable';
import PublicFilterDropdown from '../components/PublicFilterDropdown';
import ContactCell from '../components/ContactCell';
import { DirectoryHeader, DirectoryPage, FilterBy, LastUpdated } from '../components/Directory';
import { COORDINATOR_STATES, COORDINATORS_LAST_UPDATED, STATE_COORDINATORS } from '../data/contactData';

// Columns from the Contact Us frame (Figma 1143:29711)
const COLUMNS = [
  { key: 'name',  title: 'Full Name' },
  { key: 'phone', title: 'Phone Number', render: (v) => <ContactCell number={v} /> },
  {
    key: 'email',
    title: 'Email',
    render: (v) => <a href={`mailto:${v}`} className="text-black hover:underline">{v}</a>,
  },
  { key: 'state', title: 'State' },
];

export default function ContactUs() {
  const [state, setState] = useState(COORDINATOR_STATES[0]);
  const [query, setQuery] = useState('');

  const rows = useMemo(
    () => (state === 'All States' ? STATE_COORDINATORS : STATE_COORDINATORS.filter((r) => r.state === state)),
    [state]
  );

  return (
    <DirectoryPage>
      <DirectoryHeader
        eyebrow="Contact Us"
        subject="all State Coordinators"
        query={query}
        onQueryChange={setQuery}
        searchPlaceholder="Search by state or coordinator..."
      />

      <FilterBy>
        <PublicFilterDropdown
          value={state}
          options={COORDINATOR_STATES}
          onChange={setState}
          ariaLabel="Filter by state"
        />
      </FilterBy>

      <PublicDataTable columns={COLUMNS} data={rows} searchQuery={query} pageSize={10} />

      <LastUpdated date={COORDINATORS_LAST_UPDATED} />
    </DirectoryPage>
  );
}
